import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { LastAppStateStore } from '../types'

export const useLastAppStateStore = create<LastAppStateStore>()(
    persist(
        (set) => ({
            page: null,
            action: null,
            postId: null,
            sessionId: null,

            setState: (data) => set(data),
            reset: () => set({ page: null, action: null, sessionId: null, postId: null })
        }),
        {
            name: 'last-app-state',
            partialize: (s) => ({ page: s.page, action: s.action, sessionId: s.sessionId, postId: s.postId }),
            onRehydrateStorage: () => {
                return () => {
                    try {
                        localStorage.removeItem('last-app-state') // очистили сразу после чтения
                    } catch {}
                }
            },
            skipHydration: true
        }
    )
)
